import React from "react";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import {DateUtils} from "../../module/DateUtils";
import LoadingImage from "../LoadingImage";


class Call extends React.Component {

    webService = new WebService();
    dateUtils = new DateUtils();

    constructor(props) {
        super(props);
        this.state = {serviceState: -1};
        this.getData();
    }

    getData() {
        this.webService.postWithToken(
            AppConfig.server + AppConfig.service.admin.troubleWaiting,
            null,
            this.success.bind(this),
            this.fail.bind(this)
        )
    }

    success(data) {
        this.data = data["troubles"];
        if (data["count"] > 0)
            this.setState({
                serviceState: 1
            });
        else
            this.fail();
    }

    fail() {
        this.setState({
            serviceState: 2
        });
    }


    render() {
        if (this.state.serviceState === 1) {
            return (
                <div>

                    <h3><strong>Çağrılar</strong></h3>
                    <hr/>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col">Makina Adı</th>
                            <th scope="col">Makina Grubu</th>
                            <th scope="col">Çağrı Tipi</th>
                            <th scope="col">Çağrı Zamanı</th>
                            <th scope="col">Son İşlem</th>
                            <th scope="col" style={{width: "150px"}}>İşlemler</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderUserRow()}
                        </tbody>
                    </table>
                </div>
            )
        } else if (this.state.serviceState === -1) {
            return (
                <LoadingImage/>
            )
        } else {
            return (
                <span>Aktif işlem bekleyen çağrı yoktur</span>
            )
        }
    }

    renderUserRow() {
        const data = this.data;
        const userData = [];
        for (let i = 0; i < data.length; i++) {
            const currentData = data[i];

            userData.push(<tr>
                <th>{currentData["machineName"]}</th>
                <td>{currentData["machineGroupName"]}</td>
                <td>{currentData["troubleName"]}</td>
                <td>{this.dateUtils.getStrDate(currentData["startTime"])}</td>
                <td>{currentData["workDesc"]}</td>
                <td>
                    <a href={AppConfig.pages.admin.assignCall + "?callId=" + currentData["troubleId"]}
                       style={{marginLeft: "0px"}}> Operator Ata </a>
                </td>
            </tr>)
        }

        return userData;
    }

}

export default Call;